import user from "../../assets/img/user.png";
import { Link, useNavigate } from "react-router-dom";
import { FaPowerOff, FaUserTie, FaHome } from "react-icons/fa";
import { getLoginInfo } from "../utils/storage";
import React, { useState } from "react";

function Sidebar() {
  const navigate = useNavigate();
  const username =
    getLoginInfo()?.user?.Username?.replace(/@immigration\.go\.tz$/i, "") || "";

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate("/");
  };

  const today = new Date();
  const date =
    today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear();
  const currentDate = date;
  const time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

  return (
    <>
      <div
        className="sidebar"
        data-color="purple"
        data-background-color="white"
        data-image="{}"
        alt="sidebar-1"
      >
        <div className="logo">
          <center>
            <img src={user} width="130px" height="120px" />
            <br />
            <br />
            <b>{username}</b>
            <br />
            <b>{getLoginInfo()?.user?.Station}</b>
          </center>
        </div>
        <div className="sidebar-wrapper">
          <ul className="nav">
            {getLoginInfo()?.user?.GroupName == "Super Admin" && (
              <li className="nav-item active" key="dashboard">
                <Link to="/dashboard" className="nav-link">
                  <p>
                    <FaHome style={{ fontSize: "17px" }} />
                    &nbsp;&nbsp; Main Dashboard
                  </p>
                </Link>
              </li>
            )}

            {/* <li className="nav-item" key="edituser">
              <Link to="/edituser" className="nav-link">
                <p>
                  <FaUserTie style={{ fontSize: "17px" }} />
                  &nbsp;&nbsp; Change Profile
                </p>
              </Link>
            </li> */}
            <li className="nav-item" key="signout">
              <Link to={"/"} className="nav-link" onClick={handleLogout}>
                <p>
                  <FaPowerOff style={{ fontSize: "15px" }} />
                  &nbsp;&nbsp; Sign-out
                </p>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
